
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2330_8594)"}},[_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"mask0_2330_8594","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"18","height":"19"}},[_c('path',{attrs:{"d":"M8.99965 18.1175C13.9701 18.1175 17.9994 14.0882 17.9994 9.11776C17.9994 4.14735 13.9701 0.118042 8.99965 0.118042C4.02925 0.118042 -6.10352e-05 4.14735 -6.10352e-05 9.11776C-6.10352e-05 14.0882 4.02925 18.1175 8.99965 18.1175Z","fill":"white"}})]),_c('g',{attrs:{"mask":"url(#mask0_2330_8594)"}},[_c('path',{attrs:{"d":"M26.057 0.118042H-8.0571V18.1182H26.057V0.118042Z","fill":"#D52B1E"}}),_c('path',{attrs:{"d":"M14.5404 7.45765H10.6638V3.5271H7.336V7.45765H3.45938V10.8305H7.336V14.761H10.6638V10.8305H14.5404V7.45765Z","fill":"white"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2330_8594"}},[_c('rect',{attrs:{"width":"18.0001","height":"18.0001","fill":"white","transform":"translate(-6.10352e-05 0.118042)"}})])])])
          )
        }
      }
    